module.exports = __webpack_public_path__ + "static/img/zhuce_ic_zonghefuwu@2x.6c2c68ee.png";